import fetch from 'isomorphic-fetch';
import API_URL from 'helpers/apiURL';

/* ----------------------- List ----------------------- */
export const requestList = () => ({ type: 'REQUEST_LIST' });

export const fetchList = brandId => {
  return function(dispatch) {
    dispatch(requestList());

    return fetch(`${API_URL}/model?brand_id=${brandId}`)
      .then(response => response.json())
      .then(json => dispatch(receiveList(json)));
  };
};

export const receiveList = response => ({ type: 'RECEIVE_LIST', models: response.data });

/* ----------------------- Parameters ----------------------- */
export const requestParameters = () => ({ type: 'REQUEST_PARAMETERS' });

export const fetchParameters = brandId => {
  return function(dispatch) {
    dispatch(requestParameters());

    return fetch(`${API_URL}/parameters?brand_id=${brandId}`)
      .then(response => response.json())
      .then(json => dispatch(receiveParameters(json)));
  };
};

export const receiveParameters = response => ({
  type: 'RECEIVE_PARAMETERS',
  parameters: response.data,
});

/* ----------------------- ServiceCategories ----------------------- */
export const requestServiceCategories = () => ({ type: 'REQUEST_SERVICES' });

export const fetchServiceCategories = (
  { vehicle_id, engine_id, transmission_id, traction_id },
  brandId
) => {
  return function(dispatch) {
    dispatch(requestServiceCategories());

    const url = `${API_URL}/service?brand_id=${brandId}&vehicle_id=${vehicle_id}&engine_id=${engine_id}&transmission_id=${transmission_id}&traction_id=${traction_id}`;

    return fetch(url)
      .then(response => response.json())
      .then(json => dispatch(receiveServiceCategories(json)));
  };
};

export const receiveServiceCategories = response => ({
  type: 'RECEIVE_SERVICES',
  categories: response.data,
  addons: response.metadata.addons.length ? response.metadata.addons[0].model_services : [],
  priceList: response.metadata.price_list,
});

/* ----------------------- Calendar ----------------------- */
export const requestCalendar = () => ({ type: 'REQUEST_CALENDAR' });

export const fetchCalendar = (
  { vehicle_id, engine_id, transmission_id, traction_id, services, from, to, workshop_id },
  brandId
) => {
  return function(dispatch) {
    dispatch(requestCalendar());

    const url = `${API_URL}/calendar?brand_id=${brandId}&vehicle_id=${vehicle_id}&engine_id=${engine_id}&transmission_id=${transmission_id}&traction_id=${traction_id}&services=${encodeURIComponent(
      services
    )}&from=${from}&to=${to}&workshop_id=${workshop_id}`;

    return fetch(url)
      .then(response => response.json())
      .then(json => dispatch(receiveCalendar(json)));
  };
};

export const receiveCalendar = response => ({ type: 'RECEIVE_CALENDAR', calendar: response.data });

/* ----------------------- Timesheet ----------------------- */
export const requestTimesheet = () => ({ type: 'REQUEST_TIMESHEET' });

export const fetchTimesheet = (
  { workshop_id, vehicle_id, engine_id, transmission_id, traction_id, services, from, to, date },
  brandId
) => {
  return function(dispatch) {
    dispatch(requestTimesheet());

    const url = `${API_URL}/timesheet?brand_id=${brandId}&workshop_id=${workshop_id}&vehicle_id=${vehicle_id}&engine_id=${engine_id}&transmission_id=${transmission_id}&traction_id=${traction_id}&services=${encodeURIComponent(
      services
    )}&date=${date}`;

    return fetch(url)
      .then(response => response.json())
      .then(json => dispatch(receiveTimesheet(json)));
  };
};

export const receiveTimesheet = response => ({
  type: 'RECEIVE_TIMESHEET',
  timesheet: response.data,
});
